import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

function loadLocales() {
  const resources: Record<string, any> = { "pt-BR": {}, "pt-PT": {}, "en-US": {}, "es-ES": {} };

  const moduleContext = (require as any).context("../modules", true, /presentation\/locales\/(pt-BR|pt-PT|en-US|es-ES)\.json$/);

  const componentContext = (require as any).context("../components", true, /locales\/(pt-BR|pt-PT|en-US|es-ES)\.json$/);

  const pagesContext = (require as any).context("../pages", true, /locales\/(pt-BR|pt-PT|en-US|es-ES)\.json$/);

  const processContext = (context: any, baseFolder: "modules" | "components" | "pages") => {
    context.keys().forEach((key: string) => {
      const lang = key.match(/(pt-BR|pt-PT|en-US|es-ES)\.json$/)?.[1] as "pt-BR" | "pt-PT" | "en-US" | "es-ES";

      const parts = key.split("/");
      const namespaceIndex = parts.indexOf(baseFolder) + 1;
      const namespace = parts[namespaceIndex];

      if (!resources[lang]) resources[lang] = {};
      resources[lang][namespace] = {
        ...(resources[lang][namespace] || {}),
        ...context(key),
      };
    });
  };

  processContext(moduleContext, "modules");
  processContext(componentContext, "components");
  processContext(pagesContext, "pages");

  return resources;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "pt-PT", "en-US", "es-ES"],
    debug: process.env.NODE_ENV === "development",
    interpolation: { escapeValue: false },
    resources: loadLocales(),
  });
